import { createFileRoute } from '@tanstack/react-router'

import DetailKepPage from '@/components/pages/backoffice/_klb-petani/_kep/_$kepId/containers/DetailKepPage'

export const Route = createFileRoute('/_backoffice/klb-petani/kep/$kepId/')({
  component: DetailKepPage
})
